import utils from "../utils";

function init() {

	let imgs = document.querySelectorAll("[data-srcset]");

	function initAnimationThumb(elem) {

		let sources = elem.querySelectorAll('source');

		utils.forEach(sources, function(source_key, source){

			let srcset = source.getAttribute("data-srcset");

			source.setAttribute("srcset", srcset);
			source.removeAttribute("data-srcset");

		});

		let parent = elem.parentElement,
			thumb = parent.querySelector(".thumb"),
			img = elem.querySelector("img");

		utils.isImageLoaded(img, function () {

			parent.classList.add("image-loaded");

			hideThumb(thumb);

		});
	}

	function startObserverLazy() {

		let lazyImageObserver = new IntersectionObserver(

			function (entries) {

				entries.forEach(function (entry) {

					if (entry.isIntersecting || entry.intersectionRatio > 0) {

						let lazyImage = entry.target;
						initAnimationThumb(lazyImage);
						lazyImageObserver.unobserve(lazyImage);

					}

				});

			},
			{
				rootMargin: "20% 0px 20% 0px",
				threshold: 0.5,
			}
		);

		utils.forEach(imgs, function (index, elem) {

			elem = elem.parentElement;
			lazyImageObserver.observe(elem);

		});

	}

	async function hideThumb(thumb) {

		if (thumb) {

			await new Promise(resolve => setTimeout(resolve, 1000));
			thumb.classList.add('display-none');

		}

	}

	if (imgs.length > 0) {
		startObserverLazy();
	}

}

export default {init};
